import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import iconLibrary from '../../iconLibrary';

@Component({
  selector: 'wct-error-message',
  imports: [],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorMessageComponent {
  @Input({ required: true }) public errorMessage!: string;
  protected readonly iconLibrary = iconLibrary;
}

